module.exports = __webpack_public_path__ + "static/media/info.5aa14995.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/info.png
// module id = 252
// module chunks = 0